import React, { useState, useRef, useEffect } from "react";
import Header from "../components/Header";
import Leftmenu from "../components/Leftmenu";
import validator from "validator";
import { useNavigate } from "react-router-dom";
import { useOutletContext } from "react-router-dom";

function Profileinformation() {

    // Step 1 Logic 
    const present_address = useRef();
    const permanent_address = useRef();
    const [step, setStep] = useState(1);
    const [loader, setLoader] = useState(false);
    const [personalform, setPersonalform] = useState({
        dob: "",
        gender: "",
        marital_status: "",
        emergency_contact: "",
        whatsapp: "",
        present_address: "",
        permanent_address: "",
    });
    const [ugCourses, setUgCourses] = useState([]);
    const [pgCourses, setPgCourses] = useState([]);
    const navigate = useNavigate();
    const [personalerrors, setPersonalerrors] = useState({});
    const { user, token, loading } = useOutletContext();


    const getCourses = () => {
        // Fetch programs from TIUT official API and filter into UG and PG
        fetch("https://admin.tiut.ac.in/api/v1/programs")
            .then((response) => response.json())
            .then((data) => {
                const programList = Array.isArray(data) ? data : data?.data || [];
                const ugList = programList.filter(
                    (p) => String(p.program_type || p.course_type).toUpperCase() === "UG"
                );
                const pgList = programList.filter(
                    (p) => String(p.program_type || p.course_type).toUpperCase() === "PG"
                );

                if (ugList.length > 0) {
                    setUgCourses(ugList);
                }
                if (pgList.length > 0) {
                    setPgCourses(pgList);
                }

                // If either is empty (e.g. API currently only has UG programs), fallback to local backend courses
                if (ugList.length === 0 || pgList.length === 0) {
                    fetchLocalCourses(ugList.length > 0, pgList.length > 0);
                }
            })
            .catch((error) => {
                console.error("Error fetching programs from admin.tiut.ac.in:", error);
                // Fallback to local courses API if external fetch fails
                fetchLocalCourses(false, false);
            });
    };

    const fetchLocalCourses = (hasUgAlready = false, hasPgAlready = false) => {
        fetch("/api/courses", {
            method: "POST",
            headers: {
                Authorization: `bearer ${token}`,
            },
        })
            .then((response) => response.json())
            .then((data) => {
                if (!hasUgAlready && data.ug_courses && data.ug_courses.length > 0) {
                    setUgCourses(data.ug_courses);
                }
                if (!hasPgAlready && data.pg_courses && data.pg_courses.length > 0) {
                    setPgCourses(data.pg_courses);
                }
            })
            .catch((err) => {
                console.error("Error fetching local courses fallback:", err);
            });
    };

    useEffect(() => {
        getCourses();
        if (user) {
            if (user.profile_status == "step1") {
                setStep(2);
            }
            if (user.profile_status == "step2") {
                setStep(3);
            }
            if (user.profile_status == "step3") {
                setStep(4);
            }
        }
    }, [user]);

    const handlePersonal = (e) => {
        setPersonalform({ ...personalform, [e.target.name]: e.target.value });
    };
    const validatePersonal = () => {
        let newErrors = {};
        if (validator.isEmpty(personalform.dob))
            newErrors.dob = "Date of birth is required";
        if (validator.isEmpty(personalform.gender))
            newErrors.gender = "Gender is required";
        if (validator.isEmpty(personalform.marital_status))
            newErrors.marital_status = "Marital status is required";
        if (validator.isEmpty(personalform.emergency_contact))
            newErrors.emergency_contact = "Emergency contact is required";
        if (validator.isEmpty(personalform.whatsapp))
            newErrors.whatsapp = "WhatsApp is required";
        if (validator.isEmpty(personalform.present_address))
            newErrors.present_address = "Present address is required";
        if (validator.isEmpty(personalform.permanent_address))
            newErrors.permanent_address = "Permanent address is required";
        if (validator.isEmpty(personalform.about)) {
            newErrors.about = "About is required";
        }
        return newErrors;
    };
    const handleSubmitPersonal = (e) => {
        e.preventDefault();

        setLoader(true);

        let errors = validatePersonal();
        if (Object.keys(errors).length !== 0) {
            setLoader(false);
            setPersonalerrors(errors);
            console.log("Errors:", errors);
            return false;
        }

        const personaldata = new FormData();

        // Append text fields
        for (const key in personalform) {
            if (key !== "profile_picture") {
                personaldata.append(key, personalform[key]);
            }
        }

        // Append file
        if (personalform.profile_picture) {
            personaldata.append(
                "profile_picture",
                personalform.profile_picture
            );
        }

        fetch(`/api/update-personal-information`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
            },
            body: personaldata,
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.errors) {
                    setLoader(false);
                    setPersonalerrors(data.errors);
                }
                if (data.message) {
                    setStep(2);
                    setLoader(false);
                }

                setLoader(false);
            })
            .catch((error) => {
                console.error("Error:", error);
                setLoader(false);
            });

        return false;
    };





    // Handle Academic Logic
    const [academicform, setAcademicform] = useState({
        tenth_institution: "",
        tenth_board: "",
        tenth_year: "",
        tenth_percentage: "",
        tenth_certificate: "",
        is_diploma: "",
        twelth_institution: "",
        twelth_board: "",
        twelth_year: "",
        twelth_percentage: "",
        twelth_certificate: "",
        graduation_from_snu: "",
        graduation_institution: "",
        graduation_degree: "",
        graduation_course: "",
        course_id_ug: "",
        graduation_start_year: "",
        graduation_end_year: "",
        graduation_percentage: "",
        graduation_pursuing: "",
        graduation_certificate: "",
        is_snu_pg: "",
        post_graduation: "",
        post_graduation_institution: "",
        post_graduation_degree: "",
        post_graduation_course: "",
        course_id_pg: "",
        post_graduation_start_year: "",
        post_graduation_end_year: "",
        post_graduation_percentage: "",
        post_graduation_certificate: "",
        has_phd: "",
        is_snu_phd: "",
        phd_institution: "",
        phd_field: "",
        phd_topic: "",
        phd_start_year: "",
        phd_end_year: "",
        phd_pursuing: "",
        phd_certificate: "",

    });
    const [academicerrors, setAcademicerrors] = useState({});
    const [hasPhd, setHasPhd] = useState(false);
    const [hasPostgrad, sethasPostgrad] = useState(false);
    const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB in bytes

    const handleAcademicFileChange = (e) => {
        const file = e.target.files[0];
        const { name } = e.target;

        if (file) {
            if (file.size > MAX_FILE_SIZE) {
                // remove file from input
                e.target.value = null;

                // show error
                setAcademicerrors((prev) => ({
                    ...prev,
                    [name]: "File size must not exceed 2MB",
                }));

                // set empty string instead of undefined
                setAcademicform((prev) => ({
                    ...prev,
                    [name]: "",
                }));

                return;
            }

            // ✅ if valid file
            setAcademicerrors((prev) => ({
                ...prev,
                [name]: "",
            }));

            setAcademicform((prev) => ({
                ...prev,
                [name]: file,
            }));
        } else {
            // ✅ if no file chosen
            setAcademicform((prev) => ({
                ...prev,
                [name]: "",
            }));
        }
    };

    const handleAcademicChange = (e) => {
        const { name, type, value, files } = e.target;
        setAcademicform({
            ...academicform,
            [name]: type === "file" ? files[0] : value, // ✅ store file object
        });
        console.log(academicform);
    }

    const adcademicValidate = () => {
        let AcademicErrors = {};
        const fileTypes = ['image/jpeg', 'application/pdf'];

        if (validator.isEmpty(academicform?.tenth_institution))
            AcademicErrors.tenth_institution = "College name is required";
        if (validator.isEmpty(academicform?.tenth_board))
            AcademicErrors.tenth_board = "Please fill board name";
        if (validator.isEmpty(academicform?.tenth_year))
            AcademicErrors.tenth_year = "Please fill year";
        if (validator.isEmpty(academicform?.tenth_percentage))
            AcademicErrors.tenth_percentage = "Fill percentage";
        if (validator.isEmpty(academicform?.is_diploma))
            AcademicErrors.is_diploma = "Please select option";
        if (validator.isEmpty(academicform?.twelth_institution))
            AcademicErrors.twelth_institution = "College name is required";
        if (validator.isEmpty(academicform?.twelth_board))
            AcademicErrors.twelth_board = "Please fill board name";
        if (validator.isEmpty(academicform?.twelth_year))
            AcademicErrors.twelth_year = "Please fill year";
        if (validator.isEmpty(academicform?.twelth_percentage))
            AcademicErrors.twelth_percentage = "Fill percentage";

        if (validator.isEmpty(academicform?.graduation_pursuing))
            AcademicErrors.graduation_pursuing = "Please select option";
        if (validator.isEmpty(academicform?.post_graduation))
            AcademicErrors.post_graduation = "Please select option";
        if (validator.isEmpty(academicform?.has_phd))
            AcademicErrors.has_phd = "Select option";


        console.log(academicform);


        return AcademicErrors;
    }
    const handleAcademic = (e) => {
        e.preventDefault();
        console.log(academicform);
        setLoader(true);

        let errors = adcademicValidate();
        if (Object.keys(errors).length !== 0) {
            setLoader(false);
            setAcademicerrors(errors);
            console.log("Errors:", errors);
            return false;
        }
        setAcademicerrors({});

        const academicdata = new FormData();

        for (const key in academicform) {
            academicdata.append(key, academicform[key]);
        }

        fetch('api/academic-update', {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
            },
            body: academicdata,
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.extraerror) {
                    setLoader(false);
                    setAcademicerrors(data.extraerror);
                } else {
                    console.log("Success:", data);
                    setLoader(false);
                    setStep(3);
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
        console.log(academicdata);
    }



    //Handle Professional Information Logic
    const [professionalform, setProfessionalform] = useState({

    });
    const [professional, setProfessional] = useState([

    ]);
    const addRow = () => {
        setProfessional([...professional, { organisation: "", designation: "", payscale: "", start_date: "", end_date: "", is_current: "" }]);
    };

    const removeRow = (index) => {
        setProfessional(professional.filter((_, i) => i !== index));
    };
    const [professionalerrors, setProfessionalerrors] = useState({});
    const handleProfessionalChange = (e) => {
        setProfessionalform({
            ...professionalform,
            [e.target.name]: e.target.value
        })

    }
    const handleProfessionalWorkChange = (index, field, value) => {
        const updated = [...professional];
        updated[index][field] = value;
        setProfessional(updated);
    }

    const handleSubmitProfessional = (e) => {
        e.preventDefault();
        let final = {
            professionalinfo: professionalform,
            workExperience: professional
        }
        console.log(final);
        fetch('api/professional-update', {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify(final),
        })

            .then((response) => response.json())
            .then((data) => {
                if (data.extraerror) {
                    setLoader(false);
                    setProfessionalerrors(data.extraerror);
                } else if (data.data && data.message) {
                    console.log("Success:", data);
                    setLoader(false);
                    console.log("navigate");
                    setStep(4);
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            })
    }



    // Feed back form Logic

    const [feedbackform, setFeedbackform] = useState({
        received_degree_certificate: "",
        has_pending_marksheet: "",
        semester: "",
        received_caution_money: "",
        receipt: "",
        has_pending_doc_or_amount: "",
        pending_doc_or_amount: ""
    });
    const [feedbackerrors, setFeedbackerrors] = useState({});

    const handleFeedbackChange = (e) => {
        const { name, type, value, files } = e.target;
        setFeedbackform({
            ...feedbackform,
            [name]: type === "file" ? files[0] : value, // ✅ store file object
        })
        console.log(feedbackform);
    }
    const handleSubmitFeedback = (e) => {
        e.preventDefault();
        console.log(feedbackform);
        const feedbackdata = new FormData();
        for (const key in feedbackform) {
            feedbackdata.append(key, feedbackform[key]);
        }

        fetch('/api/feedback-update', {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,

            },
            body: feedbackdata,
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.errors) {
                    setLoader(false);
                    setFeedbackerrors(data.errors);
                } else if (data.data && data.message) {
                    console.log("Success:", data);
                    setLoader(false);
                    console.log("navigate");
                    navigate("/contact-admin");
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            })
    }



    return (
        <div>
            <Header />
            <Leftmenu />

            {loading ? <div className="preloader"></div> : ""}
            {step == 1 && (
                <div
                    className="main-content bg-lightblue theme-dark-bg right-chat-active"
                    style={{ minHeight: "100vh" }}
                >
                    <div className="middle-sidebar-bottom">
                        <div className="middle-sidebar-left">
                            <div className="middle-wrap">
                                <div className="card w-100 border-0 bg-white shadow-xs p-0 mb-4">
                                    <div className="card-body p-4 w-100 bg-current border-0 d-flex rounded-3">
                                        <a
                                            href="#"
                                            className="d-inline-block mt-2"
                                        >
                                            <i className="ti-arrow-left font-sm text-white" />
                                        </a>
                                        <h4 className="font-xs text-white fw-600 ms-4 mb-0 mt-2">
                                            Personal Information
                                        </h4>
                                    </div>
                                    <div className="card-body p-lg-5 p-4 w-100 border-0">
                                        <form onSubmit={handleSubmitPersonal}>
                                            <div className="row">
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Write About Yourself
                                                            <span className="text-danger">*</span>
                                                        </label>
                                                        <textarea
                                                            name="about"
                                                            className="form-control"
                                                            onChange={
                                                                handlePersonal
                                                            }
                                                            required
                                                        ></textarea>
                                                        {personalerrors.about && (
                                                            <span className="text-danger">
                                                                {
                                                                    personalerrors.about
                                                                }
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Date of Birth
                                                            <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="date"
                                                            name="dob"
                                                            className="form-control"
                                                            onChange={
                                                                handlePersonal
                                                            }
                                                            required
                                                        />
                                                        {personalerrors.dob && (
                                                            <span className="text-danger">
                                                                {
                                                                    personalerrors.dob
                                                                }
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-6 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Gender
                                                            <span className="text-danger">*</span>
                                                        </label>
                                                        <select
                                                            name="gender"
                                                            className="form-select"
                                                            onChange={
                                                                handlePersonal
                                                            }
                                                            required
                                                        >
                                                            <option value="">
                                                                Select Gender
                                                            </option>
                                                            <option value="male">
                                                                Male
                                                            </option>
                                                            <option value="female">
                                                                Female
                                                            </option>
                                                            <option value="other">
                                                                Other
                                                            </option>
                                                        </select>
                                                        {personalerrors.gender && (
                                                            <span className="text-danger">
                                                                {
                                                                    personalerrors.gender
                                                                }
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Marital Status  <span className="text-danger">*</span>
                                                        </label>
                                                        <select
                                                            name="marital_status"
                                                            className="form-select"
                                                            onChange={
                                                                handlePersonal
                                                            }
                                                            required
                                                        >
                                                            <option value="">
                                                                Select Marital
                                                                Status
                                                            </option>
                                                            <option value="single">
                                                                Single
                                                            </option>
                                                            <option value="married">
                                                                Married
                                                            </option>
                                                        </select>
                                                        {personalerrors.marital_status && (
                                                            <span className="text-danger">
                                                                {
                                                                    personalerrors.marital_status
                                                                }
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Emergency Number  <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="emergency_contact"
                                                            className="form-control"
                                                            onChange={
                                                                handlePersonal
                                                            }
                                                            required
                                                        />
                                                        {personalerrors.emergency_contact && (
                                                            <span className="text-danger">
                                                                {
                                                                    personalerrors.emergency_contact
                                                                }
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Whats App Number  <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="whatsapp"
                                                            className="form-control"
                                                            onChange={
                                                                handlePersonal
                                                            }
                                                            required
                                                        />
                                                        {personalerrors.whatsapp && (
                                                            <span className="text-danger">
                                                                {
                                                                    personalerrors.whatsapp
                                                                }
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Present Address   <span className="text-danger">*</span>
                                                        </label>
                                                        <textarea
                                                            ref={
                                                                present_address
                                                            }
                                                            name="present_address"
                                                            className="form-control"
                                                            style={{
                                                                height: "100px",
                                                            }}
                                                            onChange={
                                                                handlePersonal
                                                            }
                                                            required
                                                        />
                                                        {personalerrors.present_address && (
                                                            <span className="text-danger">
                                                                {
                                                                    personalerrors.present_address
                                                                }
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Permanent Address   <span className="text-danger">*</span>
                                                        </label>
                                                        <textarea
                                                            ref={
                                                                permanent_address
                                                            }
                                                            name="permanent_address"
                                                            className="form-control"
                                                            style={{
                                                                height: "100px",
                                                            }}
                                                            onChange={
                                                                handlePersonal
                                                            }
                                                            required
                                                        />
                                                        {personalerrors.permanent_address && (
                                                            <span className="text-danger">
                                                                {
                                                                    personalerrors.permanent_address
                                                                }
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Profile Picture   <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="file"
                                                            name="profile_picture"
                                                            className="form-control"
                                                            accept="image/*"
                                                            onChange={(e) =>
                                                                setPersonalform(
                                                                    {
                                                                        ...personalform,
                                                                        profile_picture:
                                                                            e
                                                                                .target
                                                                                .files[0],
                                                                    }
                                                                )
                                                            }
                                                            required
                                                        />
                                                        {personalerrors.profile_picture && (
                                                            <span className="text-danger">
                                                                {
                                                                    personalerrors.profile_picture
                                                                }
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-12 mb-0 mt-2">
                                                <button
                                                    type="submit"
                                                    className="bg-current text-center text-white font-xsss fw-600 p-3 w-175 rounded-3 d-inline-block btn"
                                                >
                                                    Save
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {step == 2 && (
                <div
                    className="main-content bg-lightblue theme-dark-bg right-chat-active"
                    style={{ minHeight: "100vh" }}
                >
                    <div className="middle-sidebar-bottom">
                        <div className="middle-sidebar-left">
                            <div className="middle-wrap">
                                <div className="card w-100 border-0 bg-white shadow-xs p-0 mb-4">
                                    <div className="card-body p-4 w-100 bg-current border-0 d-flex rounded-3">
                                        <a
                                            href="#"
                                            className="d-inline-block mt-2"
                                        >
                                            <i className="ti-arrow-left font-sm text-white" />
                                        </a>
                                        <h4 className="font-xs text-white fw-600 ms-4 mb-0 mt-2">
                                            Academic Information
                                        </h4>
                                    </div>
                                    <div className="card-body p-lg-5 p-4 w-100 border-0">
                                        <form onSubmit={handleAcademic}>
                                            <div className="row">
                                                <h3 className="fw-600 font-xss mb-3">
                                                    Class 10<sup>th</sup>{" "}
                                                    Information
                                                </h3>
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            10<sup>th</sup>{" "}
                                                            Institution
                                                            <span className="text-danger">
                                                                *
                                                            </span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="tenth_institution"
                                                            className="form-control"
                                                            onChange={
                                                                handleAcademicChange
                                                            }
                                                        />
                                                        {academicerrors.tenth_institution && (
                                                            <span className="text-danger">
                                                                {
                                                                    academicerrors.tenth_institution
                                                                }
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="col-lg-6 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            10<sup>th</sup>{" "}
                                                            Board
                                                            <span className="text-danger">
                                                                *
                                                            </span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="tenth_board"
                                                            className="form-control"
                                                            onChange={
                                                                handleAcademicChange
                                                            }
                                                        />
                                                        {academicerrors.tenth_board && (
                                                            <span className="text-danger">
                                                                {
                                                                    academicerrors.tenth_board
                                                                }
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            10<sup>th</sup> Year
                                                            <span className="text-danger">
                                                                *
                                                            </span>
                                                        </label>
                                                        <input
                                                            type="number"
                                                            name="tenth_year"
                                                            className="form-control"
                                                            onChange={
                                                                handleAcademicChange
                                                            }
                                                        />
                                                        {academicerrors.tenth_year && (
                                                            <span className="text-danger">
                                                                {
                                                                    academicerrors.tenth_year
                                                                }
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="col-lg-6 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            10<sup>th</sup>{" "}
                                                            Percentage
                                                            <span className="text-danger">
                                                                *
                                                            </span>
                                                        </label>
                                                        <input
                                                            type="number"
                                                            name="tenth_percentage"
                                                            className="form-control"
                                                            onChange={
                                                                handleAcademicChange
                                                            }
                                                        />
                                                        {academicerrors.tenth_percentage && (
                                                            <span className="text-danger">
                                                                {
                                                                    academicerrors.tenth_percentage
                                                                }
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            10<sup>th</sup>{" "}
                                                            Certificate
                                                            <span className="text-danger">
                                                                *(jpg,png,pdf)
                                                            </span>
                                                        </label>
                                                        <input
                                                            type="file"
                                                            name="tenth_certificate"
                                                            className="form-control"
                                                            accept=".jpg,.png,.pdf"
                                                            onChange={(e) =>
                                                                handleAcademicFileChange(
                                                                    e
                                                                )
                                                            }
                                                        />
                                                        {academicerrors.tenth_certificate && (
                                                            <span className="text-danger">
                                                                {
                                                                    academicerrors.tenth_certificate
                                                                }
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                <h3 className="fw-600 font-xss mb-3">
                                                    Class 12<sup>th</sup>/
                                                    Diploma Information
                                                </h3>

                                                <div className="col-lg-6 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Is Diploma?
                                                        </label>
                                                        <span className="text-danger">
                                                            *
                                                        </span>
                                                        <select
                                                            name="is_diploma"
                                                            className="form-select"
                                                            onChange={
                                                                handleAcademicChange
                                                            }
                                                        >
                                                            <option value="">
                                                                Select
                                                            </option>
                                                            <option value="1">
                                                                Yes
                                                            </option>
                                                            <option value="0">
                                                                No
                                                            </option>
                                                        </select>
                                                        {academicerrors.is_diploma && (
                                                            <span className="text-danger">
                                                                {
                                                                    academicerrors.is_diploma
                                                                }
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            12<sup>th</sup> /
                                                            Diploma Institution
                                                            <span className="text-danger">
                                                                *
                                                            </span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="twelth_institution"
                                                            className="form-control"
                                                            onChange={
                                                                handleAcademicChange
                                                            }
                                                        />
                                                        {academicerrors.twelth_institution && (
                                                            <span className="text-danger">
                                                                {
                                                                    academicerrors.twelth_institution
                                                                }
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            12<sup>th</sup> /
                                                            Diploma Board
                                                            <span className="text-danger">
                                                                *
                                                            </span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="twelth_board"
                                                            className="form-control"
                                                            onChange={
                                                                handleAcademicChange
                                                            }
                                                        />
                                                        {academicerrors.twelth_board && (
                                                            <span className="text-danger">
                                                                {
                                                                    academicerrors.twelth_board
                                                                }
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="col-lg-6 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            12<sup>th</sup> /
                                                            Diploma Year
                                                            <span className="text-danger">
                                                                *
                                                            </span>
                                                        </label>
                                                        <input
                                                            type="number"
                                                            name="twelth_year"
                                                            className="form-control"
                                                            onChange={
                                                                handleAcademicChange
                                                            }
                                                        />
                                                        {academicerrors.twelth_year && (
                                                            <span className="text-danger">
                                                                {
                                                                    academicerrors.twelth_year
                                                                }
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            12<sup>th</sup>/
                                                            Diploma Percentage
                                                            <span className="text-danger">
                                                                *
                                                            </span>
                                                        </label>
                                                        <input
                                                            type="number"
                                                            name="twelth_percentage"
                                                            className="form-control"
                                                            onChange={
                                                                handleAcademicChange
                                                            }
                                                        />
                                                        {academicerrors.twelth_percentage && (
                                                            <span className="text-danger">
                                                                {
                                                                    academicerrors.twelth_percentage
                                                                }
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="col-lg-6 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            12<sup>th</sup>/
                                                            Diploma Certificate{" "}
                                                            <span className="text-danger">
                                                                *(jpg,png,pdf)
                                                            </span>
                                                        </label>
                                                        <input
                                                            type="file"
                                                            name="twelth_certificate"
                                                            className="form-control"
                                                            accept=".jpg,.png,.pdf"
                                                            onChange={(e) =>
                                                                handleAcademicFileChange(
                                                                    e
                                                                )
                                                            }
                                                        />
                                                        {academicerrors.twelth_certificate && (
                                                            <span className="text-danger">
                                                                {
                                                                    academicerrors.twelth_certificate
                                                                }
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>

                                                <h3 className="fw-600 font-xss mb-3">
                                                    Graduation Information
                                                </h3>

                                                <div className="col-lg-6 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Graduation From TIUT?
                                                            <span className="text-danger">
                                                                *
                                                            </span>
                                                        </label>
                                                        <select
                                                            className="form-select"
                                                            name="graduation_from_snu"
                                                            onChange={(e) => {
                                                                if (e.target.value === "Yes") {
                                                                    setAcademicform({
                                                                        ...academicform,
                                                                        graduation_institution: "Techno India University Tripura",
                                                                        graduation_from_snu: 1,
                                                                    })

                                                                } else {
                                                                    setAcademicform({
                                                                        ...academicform,
                                                                        graduation_institution: "",
                                                                        graduation_from_snu: 0,
                                                                    })

                                                                }
                                                            }}
                                                            required
                                                        >
                                                            <option>
                                                                Select
                                                            </option>
                                                            <option value="Yes">
                                                                Yes
                                                            </option>
                                                            <option value="No">
                                                                No
                                                            </option>
                                                        </select>

                                                    </div>
                                                </div>

                                                <div className="col-lg-6 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Graduation
                                                            Institution{" "}

                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="graduation_institution"
                                                            className="form-control"
                                                            onChange={
                                                                handleAcademicChange
                                                            }
                                                            value={
                                                                academicform.graduation_institution
                                                            }
                                                        />
                                                        {academicerrors.graduation_institution && (
                                                            <span className="text-danger">
                                                                {
                                                                    academicerrors.graduation_institution
                                                                }
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Graduation Degree{" "}

                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="graduation_degree"
                                                            className="form-control"
                                                            onChange={
                                                                handleAcademicChange
                                                            }
                                                        />
                                                        {academicerrors.graduation_degree && (
                                                            <span className="text-danger">
                                                                {
                                                                    academicerrors.graduation_degree
                                                                }
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>

                                                {academicform.graduation_from_snu === 1 && (
                                                    <div className="col-lg-6 mb-3">
                                                        <div className="form-group">
                                                            <label className="mont-font fw-600 font-xsss">
                                                                Graduation Course
                                                            </label>
                                                            <select
                                                                name="graduation_course"
                                                                className="form-select"
                                                                value={academicform.course_name || ""} // ✅ controlled input
                                                                onChange={handleAcademicChange}
                                                                required
                                                            >
                                                                <option value="">Select</option>
                                                                {ugCourses.map((course) => (
                                                                    <option key={course.course_name} value={course.course_name}>
                                                                        {course.course_name || course.name} {/* ✅ safe access */}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                )}

                                                {
                                                    academicform.graduation_from_snu === 0 && (
                                                        <div className="col-lg-6 mb-3">
                                                            <div className="form-group">
                                                                <label className="mont-font fw-600 font-xsss">
                                                                    Graduation Course{" "}

                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="graduation_course"
                                                                    className="form-control"
                                                                    onChange={
                                                                        handleAcademicChange
                                                                    }
                                                                />
                                                                {academicerrors.graduation_course && (
                                                                    <span className="text-danger">
                                                                        {
                                                                            academicerrors.graduation_course
                                                                        }
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    )
                                                }

                                                <div className="col-lg-6 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Graduation Start
                                                            Year{" "}

                                                        </label>
                                                        <input
                                                            type="number"
                                                            name="graduation_start_year"
                                                            className="form-control"
                                                            onChange={
                                                                handleAcademicChange
                                                            }
                                                        />
                                                        {academicerrors.graduation_start_year && (
                                                            <span className="text-danger">
                                                                {
                                                                    academicerrors.graduation_start_year
                                                                }
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="col-lg-6 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Graduation End Year{" "}

                                                        </label>
                                                        <input
                                                            type="number"
                                                            name="graduation_end_year"
                                                            className="form-control"
                                                            onChange={
                                                                handleAcademicChange
                                                            }
                                                        />
                                                        {academicerrors.graduation_end_year && (
                                                            <span className="text-danger">
                                                                {
                                                                    academicerrors.graduation_end_year
                                                                }
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Graduation
                                                            Percentage{" "}

                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="graduation_percentage"
                                                            className="form-control"
                                                            onChange={
                                                                handleAcademicChange
                                                            }
                                                        />
                                                        {academicerrors.graduation_percentage && (
                                                            <span className="text-danger">
                                                                {
                                                                    academicerrors.graduation_percentage
                                                                }
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="col-lg-6 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Graduation Pursuing{" "}
                                                            <span className="text-danger">
                                                                *
                                                            </span>
                                                        </label>
                                                        <select
                                                            name="graduation_pursuing"
                                                            className="form-select"
                                                            onChange={
                                                                handleAcademicChange
                                                            }
                                                        >
                                                            <option value="">
                                                                Select
                                                            </option>
                                                            <option value="1">
                                                                Yes
                                                            </option>
                                                            <option value="0">
                                                                No
                                                            </option>
                                                        </select>
                                                        {academicerrors.graduation_pursuing && (
                                                            <span className="text-danger">
                                                                {
                                                                    academicerrors.graduation_pursuing
                                                                }
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Graduation
                                                            Certificate{" "}
                                                            <span className="text-danger">
                                                                (jpg,png,pdf)
                                                            </span>
                                                        </label>
                                                        <input
                                                            type="file"
                                                            name="graduation_certificate"
                                                            className="form-control"
                                                            accept=".jpg,.png,.pdf"
                                                            onChange={(e) => {
                                                                handleAcademicFileChange(
                                                                    e
                                                                );
                                                            }}
                                                        />
                                                        {academicerrors.graduation_certificate && (
                                                            <span className="text-danger">
                                                                {
                                                                    academicerrors.graduation_certificate
                                                                }
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                <h3 className="fw-600 font-xss mb-3">
                                                    Post Graduation Information
                                                </h3>
                                                <div className="col-lg-6 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Is Post
                                                            Graduataed/Persuing{" "}
                                                            <span className="text-danger">
                                                                *
                                                            </span>
                                                        </label>
                                                        <select
                                                            name="post_graduation"
                                                            className="form-select"
                                                            onChange={(e) => {
                                                                handleAcademicChange(
                                                                    e
                                                                );
                                                                sethasPostgrad(
                                                                    e.target
                                                                        .value
                                                                );
                                                            }}
                                                        >
                                                            <option value="">
                                                                Select
                                                            </option>
                                                            <option value="1">
                                                                Yes
                                                            </option>
                                                            <option value="0">
                                                                No
                                                            </option>
                                                        </select>
                                                        {academicerrors.post_graduation && (
                                                            <span className="text-danger">
                                                                {
                                                                    academicerrors.post_graduation
                                                                }
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div
                                                    className={
                                                        hasPostgrad === "1"
                                                            ? "row"
                                                            : "d-none"
                                                    }
                                                >
                                                    <div className="col-lg-6 mb-3">
                                                        <div className="form-group">
                                                            <label className="mont-font fw-600 font-xsss">
                                                                Post Graduation From TIUT?{" "}
                                                                <span className="text-danger">
                                                                    *
                                                                </span>
                                                            </label>
                                                            <select
                                                                name="is_snu_pg"
                                                                className="form-select"
                                                                onChange={(e) => {
                                                                    if (e.target.value === "1") {
                                                                        setAcademicform({
                                                                            ...academicform,
                                                                            [e.target.name]: e.target.value,
                                                                            post_graduation_institution: "Techno India University Tripura",
                                                                        })

                                                                    } else {
                                                                        setAcademicform({
                                                                            ...academicform,
                                                                            [e.target.name]: e.target.value,
                                                                            post_graduation_institution: "",
                                                                        })
                                                                    }
                                                                }}
                                                            >
                                                                <option value="">
                                                                    Select
                                                                </option>
                                                                <option value="1">
                                                                    Yes
                                                                </option>
                                                                <option value="0">
                                                                    No
                                                                </option>
                                                            </select>
                                                            {academicerrors.is_snu_pg && (
                                                                <span className="text-danger">
                                                                    {
                                                                        academicerrors.is_snu_pg
                                                                    }
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6 mb-3">
                                                        <div className="form-group">
                                                            <label className="mont-font fw-600 font-xsss">
                                                                Post Graduation
                                                                Institution
                                                            </label>
                                                            <input
                                                                type="text"
                                                                name="post_graduation_institution"
                                                                className="form-control"
                                                                onChange={
                                                                    handleAcademicChange
                                                                }
                                                                value={
                                                                    academicform.post_graduation_institution
                                                                }
                                                            />
                                                            {academicerrors.post_graduation_institution && (
                                                                <span className="text-danger">
                                                                    {
                                                                        academicerrors.post_graduation_institution
                                                                    }
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6 mb-3">
                                                        <div className="form-group">
                                                            <label className="mont-font fw-600 font-xsss">
                                                                Post Graduation
                                                                Degree
                                                            </label>
                                                            <input
                                                                type="text"
                                                                name="post_graduation_degree"
                                                                className="form-control"
                                                                onChange={
                                                                    handleAcademicChange
                                                                }
                                                            />
                                                            {academicerrors.post_graduation_degree && (
                                                                <span className="text-danger">
                                                                    {
                                                                        academicerrors.post_graduation_degree
                                                                    }
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    {
                                                        academicform.is_snu_pg == 1 && (
                                                            <div className="col-lg-6 mb-3">
                                                                <div className="form-group">
                                                                    <label className="mont-font fw-600 font-xsss">
                                                                        Post Graduation Course
                                                                    </label>
                                                                    <select
                                                                        name="post_graduation_course"
                                                                        className="form-select"
                                                                        onChange={
                                                                            handleAcademicChange
                                                                        }
                                                                        value={
                                                                            academicform.course_name
                                                                        }
                                                                    >
                                                                        <option value="0">
                                                                            Select
                                                                        </option>
                                                                        {
                                                                            pgCourses.map((course, index) => (
                                                                                <option key={course.course_name || index} value={course.course_name}>
                                                                                    {course.course_name || course.name}
                                                                                </option>
                                                                            ))
                                                                        }
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                    {
                                                        academicform.is_snu_pg == 0 && (
                                                            <div className="col-lg-6 mb-3">
                                                                <div className="form-group">
                                                                    <label className="mont-font fw-600 font-xsss">
                                                                        Post Graduation
                                                                        Course
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        name="post_graduation_course"
                                                                        className="form-control"
                                                                        onChange={
                                                                            handleAcademicChange
                                                                        }
                                                                    />
                                                                    {academicerrors.post_graduation_course && (
                                                                        <span className="text-danger">
                                                                            {
                                                                                academicerrors.post_graduation_course
                                                                            }
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </div>)}
                                                    <div className="col-lg-6 mb-3">
                                                        <div className="form-group">
                                                            <label className="mont-font fw-600 font-xsss">
                                                                Post Graduation
                                                                Start Year
                                                            </label>
                                                            <input
                                                                type="number"
                                                                name="post_graduation_start_year"
                                                                className="form-control"
                                                                onChange={
                                                                    handleAcademicChange
                                                                }
                                                            />
                                                            {academicerrors.post_graduation_start_year && (
                                                                <span className="text-danger">
                                                                    {
                                                                        academicerrors.post_graduation_start_year
                                                                    }
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6 mb-3">
                                                        <div className="form-group">
                                                            <label className="mont-font fw-600 font-xsss">
                                                                Post Graduation
                                                                End Year
                                                            </label>
                                                            <input
                                                                type="number"
                                                                name="post_graduation_end_year"
                                                                className="form-control"
                                                                onChange={
                                                                    handleAcademicChange
                                                                }
                                                            />
                                                            {academicerrors.post_graduation_end_year && (
                                                                <span className="text-danger">
                                                                    {
                                                                        academicerrors.post_graduation_end_year
                                                                    }
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6 mb-3">
                                                        <div className="form-group">
                                                            <label className="mont-font fw-600 font-xsss">
                                                                Post Graduation
                                                                Percentage
                                                            </label>
                                                            <input
                                                                type="text"
                                                                name="post_graduation_percentage"
                                                                className="form-control"
                                                                onChange={
                                                                    handleAcademicChange
                                                                }
                                                            />
                                                            {academicerrors.post_graduation_percentage && (
                                                                <span className="text-danger">
                                                                    {
                                                                        academicerrors.post_graduation_percentage
                                                                    }
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6 mb-3">
                                                        <div className="form-group">
                                                            <label className="mont-font fw-600 font-xsss">
                                                                Post Graduation
                                                                Certificate{" "}
                                                                <span className="text-danger">
                                                                    (jpg,png,pdf)
                                                                </span>
                                                            </label>
                                                            <input
                                                                type="file"
                                                                name="post_graduation_certificate"
                                                                className="form-control"
                                                                accept=".jpg,.png,.pdf"
                                                                onChange={(e) =>
                                                                    handleAcademicFileChange(
                                                                        e
                                                                    )
                                                                }
                                                            />
                                                            {academicerrors.post_graduation_certificate && (
                                                                <span className="text-danger">
                                                                    {
                                                                        academicerrors.post_graduation_certificate
                                                                    }
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                                <h3 className="fw-600 font-xss mb-3">
                                                    PhD Information
                                                </h3>
                                                <div className="col-lg-6 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Has PhD{" "}
                                                            <span className="text-danger">
                                                                *
                                                            </span>
                                                        </label>
                                                        <select
                                                            name="has_phd"
                                                            className="form-select"
                                                            onChange={(e) => {
                                                                handleAcademicChange(
                                                                    e
                                                                );
                                                                setHasPhd(
                                                                    e.target
                                                                        .value
                                                                );
                                                            }}
                                                        >
                                                            <option value="">
                                                                Select
                                                            </option>
                                                            <option value="1">
                                                                Yes
                                                            </option>
                                                            <option value="0">
                                                                No
                                                            </option>
                                                        </select>
                                                        {academicerrors.has_phd && (
                                                            <span className="text-danger">
                                                                {
                                                                    academicerrors.has_phd
                                                                }
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div
                                                    className={
                                                        hasPhd === "1"
                                                            ? "row"
                                                            : "d-none"
                                                    }
                                                >
                                                    <div className="col-lg-6 mb-3">
                                                        <div className="form-group">
                                                            <label className="mont-font fw-600 font-xsss">
                                                                PhD From TIUT
                                                            </label>
                                                            <select
                                                                name="is_snu_phd"
                                                                className="form-select"
                                                                onChange={
                                                                    (e) => {
                                                                        if (e.target.value === "1") {
                                                                            setAcademicform({
                                                                                ...academicform,
                                                                                is_snu_phd: 1,
                                                                                phd_institution: "Techno India University Tripura",

                                                                            })
                                                                        }
                                                                        else {
                                                                            setAcademicform({
                                                                                ...academicform,
                                                                                is_snu_phd: 0,
                                                                                phd_institution: "",

                                                                            })
                                                                        }

                                                                    }
                                                                }
                                                            >
                                                                <option value="">
                                                                    Select
                                                                </option>
                                                                <option value="1">
                                                                    Yes
                                                                </option>
                                                                <option value="0">
                                                                    No
                                                                </option>
                                                            </select>
                                                            {academicerrors.phd_from_snu && (
                                                                <span className="text-danger">
                                                                    {
                                                                        academicerrors.phd_from_snu
                                                                    }
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-6 mb-3">
                                                        <div className="form-group">
                                                            <label className="mont-font fw-600 font-xsss">
                                                                PhD Institution
                                                            </label>
                                                            <input
                                                                type="text"
                                                                name="phd_institution"
                                                                className="form-control"
                                                                onChange={
                                                                    handleAcademicChange
                                                                }
                                                                value={academicform.phd_institution}
                                                            />
                                                            {academicerrors.phd_institution && (
                                                                <span className="text-danger">
                                                                    {
                                                                        academicerrors.phd_institution
                                                                    }
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6 mb-3">
                                                        <div className="form-group">
                                                            <label className="mont-font fw-600 font-xsss">
                                                                PhD Field
                                                            </label>
                                                            <input
                                                                type="text"
                                                                name="phd_field"
                                                                className="form-control"
                                                                onChange={
                                                                    handleAcademicChange
                                                                }
                                                            />
                                                            {academicerrors.phd_field && (
                                                                <span className="text-danger">
                                                                    {
                                                                        academicerrors.phd_field
                                                                    }
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6 mb-3">
                                                        <div className="form-group">
                                                            <label className="mont-font fw-600 font-xsss">
                                                                PhD Topic
                                                            </label>
                                                            <input
                                                                type="text"
                                                                name="phd_topic"
                                                                className="form-control"
                                                                onChange={
                                                                    handleAcademicChange
                                                                }
                                                            />
                                                            {academicerrors.phd_topic && (
                                                                <span className="text-danger">
                                                                    {
                                                                        academicerrors.phd_topic
                                                                    }
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6 mb-3">
                                                        <div className="form-group">
                                                            <label className="mont-font fw-600 font-xsss">
                                                                PhD Start Year
                                                            </label>
                                                            <input
                                                                type="number"
                                                                name="phd_start_year"
                                                                className="form-control"
                                                                onChange={
                                                                    handleAcademicChange
                                                                }
                                                            />
                                                            {academicerrors.phd_start_year && (
                                                                <span className="text-danger">
                                                                    {
                                                                        academicerrors.phd_start_year
                                                                    }
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6 mb-3">
                                                        <div className="form-group">
                                                            <label className="mont-font fw-600 font-xsss">
                                                                PhD End Year
                                                            </label>
                                                            <input
                                                                type="number"
                                                                name="phd_end_year"
                                                                className="form-control"
                                                                onChange={
                                                                    handleAcademicChange
                                                                }
                                                            />
                                                            {academicerrors.phd_end_year && (
                                                                <span className="text-danger">
                                                                    {
                                                                        academicerrors.phd_end_year
                                                                    }
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-6 mb-3">
                                                        <div className="form-group">
                                                            <label className="mont-font fw-600 font-xsss">
                                                                PhD Pursuing
                                                            </label>
                                                            <select
                                                                name="phd_pursuing"
                                                                className="form-select"
                                                                onChange={
                                                                    handleAcademicChange
                                                                }
                                                            >
                                                                <option value="">
                                                                    Select
                                                                </option>
                                                                <option value="1">
                                                                    Yes
                                                                </option>
                                                                <option value="0">
                                                                    No
                                                                </option>
                                                            </select>
                                                            {academicerrors.phd_pursuing && (
                                                                <span className="text-danger">
                                                                    {
                                                                        academicerrors.phd_pursuing
                                                                    }
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-6 mb-3">
                                                        <div className="form-group">
                                                            <label className="mont-font fw-600 font-xsss">
                                                                PhD Certificate{" "}
                                                                <span className="text-danger">
                                                                    (jpg,png,pdf)
                                                                </span>
                                                            </label>
                                                            <input
                                                                type="file"
                                                                name="phd_certificate"
                                                                className="form-control"
                                                                accept=".jpg,.png,.pdf"
                                                                onChange={(e) =>
                                                                    handleAcademicFileChange(
                                                                        e
                                                                    )
                                                                }
                                                            />
                                                            {academicerrors.phd_certificate && (
                                                                <span className="text-danger">
                                                                    {
                                                                        academicerrors.phd_certificate
                                                                    }
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-12 mb-0 mt-2">
                                                <button
                                                    type="submit"
                                                    className="btn bg-current text-center text-white font-xsss fw-600 p-3 w-175 rounded-3 d-inline-block"
                                                >
                                                    Save Academic Information
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {step == 3 && (
                <div
                    className="main-content bg-lightblue theme-dark-bg right-chat-active"
                    style={{ minHeight: "100vh" }}
                >
                    <div className="middle-sidebar-bottom">
                        <div className="middle-sidebar-left">
                            <div className="middle-wrap">
                                <div className="card w-100 border-0 bg-white shadow-xs p-0 mb-4">
                                    <div className="card-body p-4 w-100 bg-current border-0 d-flex rounded-3">
                                        <a
                                            href="#"
                                            className="d-inline-block mt-2"
                                        >
                                            <i className="ti-arrow-left font-sm text-white" />
                                        </a>
                                        <h4 className="font-xs text-white fw-600 ms-4 mb-0 mt-2">
                                            Professional Information
                                        </h4>
                                    </div>
                                    <div className="card-body p-lg-5 p-4 w-100 border-0">
                                        <form onSubmit={handleSubmitProfessional}>
                                            <div className="row">
                                                <div className="col-lg-6 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Employability Status
                                                        </label>
                                                        <select
                                                            name="employability_status"
                                                            className="form-select"
                                                            onChange={handleProfessionalChange}
                                                        >
                                                            <option value="">
                                                                Select
                                                            </option>
                                                            <option value="employed">
                                                                Employed
                                                            </option>
                                                            <option value="unemployed">
                                                                Unemployed
                                                            </option>
                                                            <option value="student">
                                                                Student
                                                            </option>
                                                            <option value="entrepreneur">
                                                                Entrepreneur
                                                            </option>
                                                        </select>
                                                        {personalerrors.employability_status && (
                                                            <span className="text-danger">
                                                                {
                                                                    personalerrors.employability_status
                                                                }
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Work Status
                                                        </label>
                                                        <select
                                                            name="work_status"
                                                            className="form-select"
                                                            onChange={
                                                                handleProfessionalChange
                                                            }
                                                        >
                                                            <option value="">Select</option>
                                                            <option value="none">
                                                                None
                                                            </option>
                                                            <option value="open_to_work">
                                                                Open to Work
                                                            </option>
                                                            <option value="hiring">
                                                                Hiring
                                                            </option>
                                                        </select>
                                                        {personalerrors.work_status && (
                                                            <span className="text-danger">
                                                                {
                                                                    personalerrors.work_status
                                                                }
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <h3 className="fw-700 font-xssss mt-4 mb-2">
                                                Work Experience
                                            </h3>
                                            <div className="rowmt-2">
                                                {professional.map(
                                                    (row, index) => (
                                                        <div
                                                            key={index}
                                                            className="mb-2 row"
                                                        >
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label className="mont-font fw-600 font-xsss">
                                                                        Organisation
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        name={`professional[${index}][organisation]`}
                                                                        placeholder="Organisation"
                                                                        className="form-control"
                                                                        value={
                                                                            row.organisation
                                                                        }
                                                                        onChange={(e) => {
                                                                            handleProfessionalWorkChange(
                                                                                index, "organisation", e.target.value)
                                                                        }}
                                                                        required
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">

                                                                <div className="form-group">
                                                                    <label className="mont-font fw-600 font-xsss">
                                                                        Designation
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        name={`professional[${index}][designation]`}
                                                                        placeholder="Designation"
                                                                        className="form-control"
                                                                        value={
                                                                            row.designation
                                                                        }
                                                                        onChange={(e) => {
                                                                            handleProfessionalWorkChange(
                                                                                index, "designation", e.target.value)
                                                                        }}
                                                                        required
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">

                                                                <div className="form-group">
                                                                    <label className="mont-font fw-600 font-xsss">
                                                                        Pay Scale
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        name={`professional[${index}][pay_scale]`}
                                                                        placeholder="Pay Scale"
                                                                        className="form-control"
                                                                        value={
                                                                            row.pay_scale
                                                                        }
                                                                        onChange={(e) => {
                                                                            handleProfessionalWorkChange(
                                                                                index, "pay_scale", e.target.value)
                                                                        }}
                                                                        required
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">

                                                                <div className="form-group">
                                                                    <label className="mont-font fw-600 font-xsss">
                                                                        Start Date
                                                                    </label>
                                                                    <input
                                                                        type="date"
                                                                        name={`professional[${index}][start_date]`}
                                                                        placeholder="start_date"
                                                                        className="form-control"
                                                                        value={
                                                                            row.start_date
                                                                        }
                                                                        onChange={(e) => {
                                                                            handleProfessionalWorkChange(
                                                                                index, "start_date", e.target.value)
                                                                        }}
                                                                        required
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">

                                                                <div className="form-group">
                                                                    <label className="mont-font fw-600 font-xsss">
                                                                        End Date
                                                                    </label>
                                                                    <input
                                                                        type="date"
                                                                        name={`professional[${index}][end_date]`}
                                                                        placeholder="end_date"
                                                                        className="form-control"
                                                                        value={
                                                                            row.end_date
                                                                        }
                                                                        onChange={(e) => {
                                                                            handleProfessionalWorkChange(
                                                                                index, "end_date", e.target.value)
                                                                        }}

                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">

                                                                <div className="form-group">
                                                                    <label className="mont-font fw-600 font-xsss">
                                                                        Currently Working Here?
                                                                    </label>
                                                                    <select
                                                                        name={`professional[${index}][is_current]`}
                                                                        value={
                                                                            row.is_current
                                                                        }

                                                                        className="form-select"
                                                                        onChange={(e) => {
                                                                            handleProfessionalWorkChange(
                                                                                index, "is_current", e.target.value)
                                                                        }}
                                                                        required
                                                                    >
                                                                        <option value="">
                                                                            Select
                                                                        </option>
                                                                        <option value="1">
                                                                            Yes
                                                                        </option>
                                                                        <option value="0">
                                                                            No
                                                                        </option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6 mt-3">

                                                                <button
                                                                    type="button"
                                                                    className="btn btn-danger"
                                                                    onClick={() =>
                                                                        removeRow(
                                                                            index
                                                                        )
                                                                    }
                                                                >
                                                                    Remove
                                                                </button>
                                                            </div>
                                                        </div>
                                                    )
                                                )}
                                                <div className="col-md-6">

                                                    <button
                                                        type="button"
                                                        onClick={addRow}
                                                        className="btn bg-current text-center text-white font-xsss fw-600 p-3 w-175 rounded-3 d-inline-block mb-3"
                                                    >
                                                        Add Work Experience
                                                    </button>
                                                </div>
                                                <button
                                                    type="submit"
                                                    className="btn bg-current text-center text-white font-xsss fw-600 p-3 w-175 rounded-3 d-inline-block"
                                                >
                                                    Save
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {
                step == 4 && (
                    <div
                        className="main-content bg-lightblue theme-dark-bg right-chat-active"
                        style={{ minHeight: "100vh" }}
                    >
                        <div className="middle-sidebar-bottom">
                            <div className="middle-sidebar-left">
                                <div className="middle-wrap">
                                    <div className="card w-100 border-0 bg-white shadow-xs p-0 mb-4">
                                        <div className="card-body p-4 w-100 bg-current border-0 d-flex rounded-3">
                                            <a
                                                href="#"
                                                className="d-inline-block mt-2"
                                            >
                                                <i className="ti-arrow-left font-sm text-white" />
                                            </a>
                                            <h4 className="font-xs text-white fw-600 ms-4 mb-0 mt-2">
                                                Feedback Form
                                            </h4>
                                        </div>
                                        <div className="card-body p-lg-5 p-4 w-100 border-0">
                                            <form onSubmit={handleSubmitFeedback}>
                                                <div className="row">
                                                    <div className="col-lg-12 mb-3">
                                                        <div className="form-group">
                                                            <label className="mont-font fw-600 font-xsss">
                                                                Have you received your Degree Certificate from TIUT?
                                                                <span className="text-danger">*</span>
                                                            </label>
                                                            <select
                                                                name="received_degree_certificate"
                                                                className="form-select"
                                                                onChange={(e) => {
                                                                    if (e.target.value == 1) {
                                                                        setFeedbackform({
                                                                            ...feedbackform,
                                                                            received_degree_certificate: 1
                                                                        })
                                                                    }
                                                                    else {
                                                                        setFeedbackform({
                                                                            ...feedbackform,
                                                                            received_degree_certificate: 1
                                                                        })
                                                                    }
                                                                }
                                                                }
                                                                required
                                                            >
                                                                <option value="">Select</option>
                                                                <option value="1">Yes</option>
                                                                <option value="0">No</option>
                                                            </select>
                                                            {feedbackerrors.received_degree_certificate && <span className="text-danger">{feedbackerrors.received_degree_certificate}</span>}

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-lg-12 mb-3">
                                                        <div className="form-group">
                                                            <label className="mont-font fw-600 font-xsss">
                                                                Do you have any pending mark sheets? If yes, then mention your semester.
                                                                <span className="text-danger">*</span>
                                                            </label>
                                                            <select
                                                                name="has_pending_marksheet"
                                                                className="form-select"
                                                                onChange={(e) => {
                                                                    if (e.target.value == 1) {
                                                                        setFeedbackform({
                                                                            ...feedbackform,
                                                                            has_pending_marksheet: 1
                                                                        })
                                                                    }
                                                                    else {
                                                                        setFeedbackform({
                                                                            ...feedbackform,
                                                                            has_pending_marksheet: 0
                                                                        })
                                                                    }
                                                                }}
                                                                required
                                                            >
                                                                <option value="">Select</option>
                                                                <option value="1">Yes</option>
                                                                <option value="0">No</option>
                                                            </select>
                                                            {feedbackerrors.has_pending_marksheet && <span className="text-danger">{feedbackerrors.has_pending_marksheet}</span>}

                                                        </div>
                                                    </div>
                                                    {
                                                        feedbackform.has_pending_marksheet == 1 && (
                                                            <div className="col-lg-12 mb-3">
                                                                <div className="form-group">
                                                                    <label className="mont-font fw-600 font-xsss">
                                                                        Semester
                                                                        <span className="text-danger">*</span>
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        name="pending_marksheet_semester"
                                                                        value={feedbackform.pending_marksheet_semester}
                                                                        onChange={(e) => handleFeedbackChange(e)}
                                                                        required
                                                                    />
                                                                    {feedbackerrors.pending_marksheet_semester && <span className="text-danger">{feedbackerrors.pending_marksheet_semester}</span>}
                                                                </div>
                                                            </div>

                                                        )
                                                    }
                                                </div>
                                                <div className="row">
                                                    <div className="col-lg-12 mb-3">
                                                        <div className="form-group">
                                                            <label className="mont-font fw-600 font-xsss">
                                                                Have you received the Caution money?
                                                                <span className="text-danger">*</span>
                                                            </label>
                                                            <select
                                                                name="received_caution_money"
                                                                className="form-select"
                                                                onChange={(e) => {
                                                                    if (e.target.value == 1) {
                                                                        setFeedbackform({
                                                                            ...feedbackform,
                                                                            received_caution_money: 1
                                                                        })
                                                                    }
                                                                    else {
                                                                        setFeedbackform({
                                                                            ...feedbackform,
                                                                            received_caution_money: 0
                                                                        })
                                                                    }
                                                                }}
                                                                required
                                                            >
                                                                <option value="">Select</option>
                                                                <option value="1">Yes</option>
                                                                <option value="0">No</option>
                                                            </select>

                                                        </div>
                                                        {feedbackerrors.received_caution_money && <span className="text-danger">{feedbackerrors.received_caution_money}</span>}
                                                    </div>
                                                    {
                                                        feedbackform.received_caution_money == 0 && (
                                                            <div className="col-lg-12 mb-3">
                                                                <div className="form-group">
                                                                    <label className="mont-font fw-600 font-xsss">
                                                                        Upload Caution Money Receipt
                                                                        <span className="text-danger">*(jpg,pdf,png)</span>
                                                                    </label>
                                                                    <input
                                                                        type="file"
                                                                        className="form-control"
                                                                        name="receipt"
                                                                        accept="image/*,application/pdf"
                                                                        onChange={(e) => handleFeedbackChange(e)}
                                                                        required
                                                                    />
                                                                </div>
                                                                {feedbackerrors.receipt && <span className="text-danger">{feedbackerrors.receipt}</span>}
                                                            </div>
                                                        )
                                                    }
                                                </div>
                                                <div className="row">
                                                    <div className="col-lg-12 mb-3">
                                                        <div className="form-group">
                                                            <label className="mont-font fw-600 font-xsss">
                                                                Do you have any pending documents or amounts to be received from this university?
                                                                <span className="text-danger">*</span>
                                                            </label>
                                                            <select
                                                                name="has_pending_doc_or_amount"
                                                                className="form-select"
                                                                onChange={(e) => {
                                                                    if (e.target.value == 1) {
                                                                        setFeedbackform({
                                                                            ...feedbackform,
                                                                            has_pending_doc_or_amount: 1
                                                                        })
                                                                    }
                                                                    else {
                                                                        setFeedbackform({
                                                                            ...feedbackform,
                                                                            has_pending_doc_or_amount: 0
                                                                        })
                                                                    }
                                                                }}
                                                                required
                                                            >
                                                                <option value="">Select</option>
                                                                <option value="1">Yes</option>
                                                                <option value="0">No</option>
                                                            </select>
                                                            {feedbackerrors.has_pending_doc_or_amount && <span className="text-danger">{feedbackerrors.has_pending_doc_or_amount}</span>}

                                                        </div>
                                                    </div>
                                                    {
                                                        feedbackform.has_pending_doc_or_amount == 1 && (
                                                            <div className="col-lg-12 mb-3">
                                                                <div className="form-group">
                                                                    <label className="mont-font fw-600 font-xsss">
                                                                        Please Elaborate your concern
                                                                        <span className="text-danger">*</span>
                                                                    </label>
                                                                    <textarea
                                                                        className="form-control"
                                                                        name="pending_doc_or_amount"
                                                                        value={feedbackform.pending_doc_or_amount}
                                                                        onChange={(e) => handleFeedbackChange(e)}
                                                                    />
                                                                </div>
                                                                {feedbackerrors.pending_doc_or_amount && <span className="text-danger">{feedbackerrors.pending_doc_or_amount}</span>}
                                                            </div>
                                                        )}
                                                </div>
                                                <button type="submit" className="btn bg-current text-white">Submit</button>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        </div>
    );
}

export default Profileinformation;
